<template>
    <v-container class="d-flex justify-center align-center pa-0 fill-height">
        <v-icon v-if="originalValue == null" color="primary" :icon="mdiPencilOutline" class="cursor-pointer" size="x-large"/>
        <span v-else>{{ originalValue }}</span>
    </v-container>
</template>

<script setup>
    import { onBeforeMount, ref } from 'vue';
    import { mdiPencilOutline } from '@mdi/js';

    const props = defineProps(['params']);

    const originalValue = ref(null);
    onBeforeMount(() => {
        // ROW PINNED BOTTOM
        if (props.params.node.group || props.params.colDef.field != 'edit' || props.params.node.rowPinned == 'bottom')
            originalValue.value = '';
    });


</script>
